import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import colors from 'shared/modules/common/constants/colors';

export default function ListItemDivider() {
  return <View style={styles.separator} />;
}

const styles = StyleSheet.create({
  separator: {
    ...(Platform.OS === 'web' ? {} : { flex: 1 }),
    height: 1,
    marginHorizontal: 16,
    backgroundColor: colors.greySuperLight,
  },
});
